import React from 'react'
import { Container } from 'react-bootstrap'

function NotFound ()
{
    return (
        <Container fluid id='notFoundPage'>
        </Container>
    )
}

export default NotFound
